import { render, staticRenderFns } from "./OdooProductDialog.vue?vue&type=template&id=1ab87cf0&scoped=true"
import script from "./OdooProductDialog.vue?vue&type=script&lang=js"
export * from "./OdooProductDialog.vue?vue&type=script&lang=js"
import style0 from "./OdooProductDialog.vue?vue&type=style&index=0&id=1ab87cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab87cf0",
  null
  
)

export default component.exports